import { render } from "./UiSettings.vue?vue&type=template&id=32e853ed&ts=true&lang=pug"
import script from "./UiSettings.vue?vue&type=script&lang=ts"
export * from "./UiSettings.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__